import React from 'react';
import { Breadcrumb } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from 'react-router-dom';
import { Routes } from '../routes';

const Breadcrumbs = () => {
  const location = useLocation();
  
  // Configuración de rutas y sus nombres
  const routeNames = {
    [Routes.Dashboard.path]: 'Dashboard',
    [Routes.Reports.path]: 'Reportes',
    [Routes.Settings.path]: 'Configuración',
    '/reports/preview': 'Vista Previa'
  };
  
  // Generar breadcrumbs basado en la ruta actual
  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    const breadcrumbs = [];
    
    // Siempre agregar Home/Dashboard como primer elemento
    breadcrumbs.push({
      name: 'Dashboard',
      path: Routes.Dashboard.path,
      icon: faHome,
      active: location.pathname === Routes.Dashboard.path
    });
    
    // Si no estamos en dashboard, agregar la ruta actual
    if (location.pathname !== Routes.Dashboard.path) {
      let currentPath = '';
      
      pathSegments.forEach((segment, index) => {
        currentPath += `/${segment}`;
        
        // Casos especiales para rutas con parámetros
        if (segment === 'preview' && pathSegments[index - 1] === 'reports') {
          breadcrumbs.push({
            name: 'Vista Previa',
            path: currentPath,
            active: true
          });
        } else if (routeNames[currentPath]) {
          breadcrumbs.push({
            name: routeNames[currentPath],
            path: currentPath,
            active: index === pathSegments.length - 1
          });
        }
      });
    }
    
    return breadcrumbs;
  };
  
  const breadcrumbs = generateBreadcrumbs();
  
  // No mostrar breadcrumbs si solo hay un elemento (Dashboard)
  if (breadcrumbs.length <= 1) {
    return null;
  }
  
  return (
    <Breadcrumb className="d-none d-md-inline-block">
      {breadcrumbs.map((crumb, index) => (
        <Breadcrumb.Item 
          key={index}
          active={crumb.active}
        >
          {crumb.active ? (
            <span className="fw-bold text-primary">
              {crumb.icon && <FontAwesomeIcon icon={crumb.icon} className="me-2" />}
              {crumb.name}
            </span>
          ) : (
            <Link to={crumb.path} className="text-decoration-none">
              {crumb.icon && <FontAwesomeIcon icon={crumb.icon} className="me-2" />}
              {crumb.name}
            </Link>
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;